// Thin progress indicator for the WearSpray IQ questionnaire wizard.
export function IQProgressBar({ step, total }) {
  const pct = Math.round((step / total) * 100);
  return (
    <div data-testid="iq-progress-bar" className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="font-mono text-[11px] tracking-[0.15em] uppercase text-zinc-500">
          Step {step} of {total}
        </span>
        <span className="font-mono text-[11px] tracking-[0.15em] text-[#ff2d78]">{pct}%</span>
      </div>
      <div className="h-1.5 w-full bg-zinc-200 rounded-full overflow-hidden">
        <div
          className="h-full bg-[#ff2d78] rounded-full transition-all duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
